unit View.Cfop.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewCfopList = class(TForm)
    btNew: TButton;
    CfopDataset: TXDataWebDataSet;
    CfopDatasetcfop_cfop: TStringField;
    CfopDatasetnome: TStringField;
    CfopDatasetexcluido: TBooleanField;
    CfopDatasetinclusao: TDateTimeField;
    CfopDatasetalteracao: TDateTimeField;
    CfopDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewCfopList: TFViewCfopList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCfopList }

procedure TFViewCfopList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewCfopList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCfopList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewCfopList, AElementID, Result, @AfterCreate);
end;

procedure TFViewCfopList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewCfopList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewCfopList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      CfopDataset.Connection.Model.DefaultSchema.FindEntityType(CfopDataset.EntitySetName),
      CfopDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewCfopList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('cfop', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    CfopDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewCfopList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.cfop.list.pagination.info');
  btNew := TButton.Create('view.cfop.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.cfop.list.table');
  cbPageSize := TComboBox.Create('view.cfop.list.cbPageSize');
  edSearch := TEdit.Create('view.cfop.list.search');
  lcPaginator := TListControl.Create('view.cfop.list.pagination');
  CfopDataset := TXDataWebDataSet.Create(Self);
  CfopDatasetcfop_cfop := TStringField.Create(Self);
  CfopDatasetnome := TStringField.Create(Self);
  CfopDatasetexcluido := TBooleanField.Create(Self);
  CfopDatasetinclusao := TDateTimeField.Create(Self);
  CfopDatasetalteracao := TDateTimeField.Create(Self);
  CfopDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  CfopDataset.BeforeLoadDFMValues;
  CfopDatasetcfop_cfop.BeforeLoadDFMValues;
  CfopDatasetnome.BeforeLoadDFMValues;
  CfopDatasetexcluido.BeforeLoadDFMValues;
  CfopDatasetinclusao.BeforeLoadDFMValues;
  CfopDatasetalteracao.BeforeLoadDFMValues;
  CfopDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewCfopList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_cfop';
      Title := 'cfop_cfop';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    CfopDataset.SetParentComponent(Self);
    CfopDataset.Name := 'CfopDataset';
    CfopDataset.EntitySetName := 'Cfop';
    CfopDataset.Connection := DMConnection.ApiConnection;
    CfopDataset.Left := 72;
    CfopDataset.Top := 144;
    CfopDatasetcfop_cfop.SetParentComponent(CfopDataset);
    CfopDatasetcfop_cfop.Name := 'CfopDatasetcfop_cfop';
    CfopDatasetcfop_cfop.FieldName := 'cfop_cfop';
    CfopDatasetcfop_cfop.Required := True;
    CfopDatasetcfop_cfop.Size := 255;
    CfopDatasetnome.SetParentComponent(CfopDataset);
    CfopDatasetnome.Name := 'CfopDatasetnome';
    CfopDatasetnome.FieldName := 'nome';
    CfopDatasetnome.Required := True;
    CfopDatasetnome.Size := 255;
    CfopDatasetexcluido.SetParentComponent(CfopDataset);
    CfopDatasetexcluido.Name := 'CfopDatasetexcluido';
    CfopDatasetexcluido.FieldName := 'excluido';
    CfopDatasetinclusao.SetParentComponent(CfopDataset);
    CfopDatasetinclusao.Name := 'CfopDatasetinclusao';
    CfopDatasetinclusao.FieldName := 'inclusao';
    CfopDatasetalteracao.SetParentComponent(CfopDataset);
    CfopDatasetalteracao.Name := 'CfopDatasetalteracao';
    CfopDatasetalteracao.FieldName := 'alteracao';
    CfopDatasetexclusao.SetParentComponent(CfopDataset);
    CfopDatasetexclusao.Name := 'CfopDatasetexclusao';
    CfopDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := CfopDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    CfopDataset.AfterLoadDFMValues;
    CfopDatasetcfop_cfop.AfterLoadDFMValues;
    CfopDatasetnome.AfterLoadDFMValues;
    CfopDatasetexcluido.AfterLoadDFMValues;
    CfopDatasetinclusao.AfterLoadDFMValues;
    CfopDatasetalteracao.AfterLoadDFMValues;
    CfopDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
